import { setTitle } from '@bizfly/shared';
import router from './router/index';
import store from './store';

// eslint-disable-next-line space-before-function-paren
router.beforeEach(async (to, from, next) => {
  // Handle auth logic here
  while (store.state.loading.loadingPage) {
    // eslint-disable-next-line no-await-in-loop
    await new Promise((r) => setTimeout(r, 100));
  }

  if (!store.state?.services?.currentService?.slug?.includes('cloud-backup')) return;

  let title = store?.state?.endpoint?.config?.services?.['cloud-backup']?.baseTitle || 'Bizfly Cloud Dashboard';
  if (to?.meta?.title) {
    title = `${to?.meta?.title} - ${title}`;
  }
  setTitle(title);
  next();
});
